export enum eProductFilterType {
    EQUAL = 1,
    LOWER = 2,
    HIGHER = 3,
    RANGE = 4,
    RANGE_INPUT = 5
}